var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pulse-loader-container d-flex justify-content-center component-section"},[_c('div',{staticClass:"text-center align-self-center"},[_c('pulse-loader',{attrs:{"loading":true,"color":"#9176cc","size":"20px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }